import React from 'react'
import PropTypes from 'prop-types'

import * as Svg from '../../Svg'

const TriggerIcon = ({ icon }) => {
  const Icon = Svg[icon]

  return <Icon className="trigger-icon" aria-hidden="true" />
}

TriggerIcon.propTypes = {
  icon: PropTypes.string.isRequired,
}

export default TriggerIcon
